<template>
  <div>
    <v-stepper v-model="careGroupStepper">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="careGroupStepper > 1">1. Basic Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="careGroupStepper > 2">1. Address</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="careGroupStepper > 3">3. Support Contact</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">4. Confirmation</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form v-model="valid1">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="name"
                  label="Care Group Name"
                  type="text"
                  hint="Please enter care group name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="phoneNumber"
                  label="Phone Number"
                  hint="Please enter care group phone number here"
                  :counter="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn color="primary" @click.native="careGroupStepper = 2" :disabled="!valid1">Continue</v-btn>
            <v-btn flat @click="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form v-model="valid2">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="unitNumber"
                  label="Unit Number"
                  type="text"
                  hint="Please enter your unit number here"
                  :counter="45"
                  maxlength="45"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="streetAddress"
                  label="Street Address"
                  hint="Please enter your street address here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="city"
                  label="City"
                  hint="Please enter your city here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="province"
                  label="Province"
                  hint="Please enter your province here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="postalCode"
                  label="Postal Code"
                  hint="Please enter your postal code here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careGroupStepper = 1">Back</v-btn>
            <v-btn color="primary" @click.native="careGroupStepper = 3" :disabled="!valid2">Continue</v-btn>
            <v-btn flat @click="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-form v-model="valid3">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="supportContactFirstName"
                  label="Support Contact - First Name"
                  type="text"
                  hint="Please enter the support contact first name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="supportContactLastName"
                  label="Support Contact - Last Name"
                  hint="Please enter the support contact last name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="supportContactPhoneNumber"
                  label="Contact - Phone Number"
                  hint="Please enter the support contact phone number here"
                  :counter="45"
                  maxlength="45"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="supportContactEmailAddress"
                  label="Contact - Email"
                  hint="Please enter the support contact email here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careGroupStepper = 2">Back</v-btn>
            <v-btn color="primary" @click.native="careGroupStepper = 4" :disabled="!valid3">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card color="grey lighten-4" class="mb-5"></v-card>
            <v-card-text class="text-xs-left">
              <p>Name: {{this.name}} </p>
            </v-card-text>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careGroupStepper = 3">Back</v-btn>
            <v-btn color="primary" @click.native="create">Submit</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>
<script>
import CareGroupService from '@/services/CareGroupService'
  export default {
    data () {
      return {
        valid: false,
        valid1: false,
        valid2: false,
        valid3: false,

        phoneMask: 'phone',
        nameRules: [
          (v) => !!v || 'This field is required'
        ],
        phoneRules: [
          (v) => !!v || 'Phone is required',
          (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Phone must be 10 digits'
        ],
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        careGroupStepper: 0,
        name: '',
        phoneNumber: '',
        unitNumber: '',
        streetAddress: '',
        city: '',
        province: '',
        postalCode: '',
        supportContactFirstName: '',
        supportContactLastName: '',
        supportContactPhoneNumber: '',
        supportContactEmailAddress: '',
        error: null
      }
    },
    methods: {
      cancel() {
        this.$router.push({
          name: 'careGroupList'
        })
      },
      async create() {
        try {
          const response = await CareGroupService.create({
            name: this.name.trim(),
            phoneNumber: this.phoneNumber.trim(),
            unitNumber: this.unitNumber.trim(),
            streetAddress: this.streetAddress.trim(),
            city: this.city.trim().toUpperCase(),
            province: this.province.trim().toUpperCase(),
            postalCode: this.postalCode.trim().toUpperCase(),
            customerAccountId: '2',
            groupNatureId: '2',
            supportContactFirstName: this.supportContactFirstName,
            supportContactLastName: this.supportContactLastName,
            supportContactPhoneNumber: this.supportContactPhoneNumber.trim(),
            supportContactEmailAddress: this.supportContactEmailAddress.trim()
          })
          this.error = "Create Successful"
          this.$router.push({
            name: 'careGroupList'
          })
        } catch (error) {
            this.error = this.handleError(error)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CareGroup/CareGroupNew.vue